import { render, staticRenderFns } from "./authorizationWx.vue?vue&type=template&id=9254a4dc&scoped=true&"
import script from "./authorizationWx.vue?vue&type=script&lang=js&"
export * from "./authorizationWx.vue?vue&type=script&lang=js&"
import style0 from "./authorizationWx.vue?vue&type=style&index=0&id=9254a4dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9254a4dc",
  null
  
)

export default component.exports